import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const adminAuth = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/admin/auth`, credentials);
    return response.data;
  } catch (error) {
    console.error('Error authenticating admin:', error);
    throw error;
  }
};

export const getUsers = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/admin/users`, credentials);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const updateUserRole = async (username, role, credentials) => {
  try {
    let postData = credentials;
    postData['access_role'] = role;
    const response = await axios.put(`${API_URL}/admin/users/${username}/role`, postData);
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

export const resetUserPassword = async (username, credentials) => {
  try {
    const response = await axios.put(`${API_URL}/admin/users/${username}/reset-password`, credentials);
    return response.data;
  } catch (error) {
    console.error('Error resetting password:', error);
    throw error;
  }
};
